import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "../../styles/hydiene-system/hygiene-command-center.css";
import HelmetWrapper from "../../HelmetWrapper";
import SummaryStatsCards from "../../components/hygiene-system/command-center/SummaryStatsCards";
import TaskCompletionMatrix from "../../components/hygiene-system/command-center/TaskCompletionMatrix";
import GymComplianceTable from "../../components/hygiene-system/command-center/GymComplianceTable";
import CommonStructured from "../../components/common-components/CommonStructured";
import { selectUser } from "../../components/auth/auth.selector";
import { fetchHygieneCommandCenterStatsData } from "../../redux/hygiene-reducers/hygieneSlice";
import CommandCenterFilter from "../../components/hygiene-system/command-center/CommandCenterFilter";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../components/common-data/Converts";
import { getCommaSeparatedValues } from "../../components/pt-trials/member-report/MemberReportMocks";
import TaskDetailModal from "../../components/hygiene-system/command-center/TaskDetailModal";
import SelectExportables from "../../components/common-components/SelectExportables";
import ModalHeader from "../../components/ModalHeader";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";

const HygieneCommandCenter = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedDate: FORMATTED_TODAY_DATE_YYYYMMDD,
    selectedDateEnd: FORMATTED_TODAY_DATE_YYYYMMDD,
    selectedCheckinTimes: [],
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    start_date: allFilters.selectedDate || "",
    end_date: allFilters.selectedDateEnd || "",
    checkin_time_filter: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [csvData, setCsvData] = useState();

  const gymComplianceExportableData = [
    "all",
    "gym_name",
    "gym_id",
    "total_tasks",
    "completed",
    "pending",
    "missed",
    "compliance_percent",
    "status_label",
    "date",
  ];

  const onCloseModal = () => {
    setModValues(iniModValues);
    setCsvData();
  };

  function getExportedData(filters) {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: "operation/hygiene/command-center/gym-compliance",
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  function getCommandCenterStats() {
    dispatch(
      fetchHygieneCommandCenterStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCommandCenterStats();
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      start_date: allFilters.selectedDate || "",
      end_date: allFilters.selectedDate || "",
      checkin_time_filter: getCommaSeparatedValues(
        allFilters.selectedCheckinTimes
      ),
    }));
  }, [allFilters]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  return (
    <HelmetWrapper title="WTF: Hygiene Command Center">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Task Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "task_details" ? "mod-width-50p p-0 mod-min-height-95vh" : ""
            }`}
          >
            {modValues.modName === "exportModal" && (
              <ModalHeader
                title="Select Fields To Export"
                onClick={onCloseModal}
              />
            )}

            {modValues.modName === "exportModal" ? (
              <div>
                <SelectExportables
                  name="gym_compliance"
                  exportableData={gymComplianceExportableData}
                  filters={filters}
                  callFunction={onClickExport}
                  isLoadingCSV={exportLoading}
                  csvData={csvData}
                  setCsvData={setCsvData}
                />
              </div>
            ) : (
              <TaskDetailModal
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                gymData={modValues.rowData}
                closeModal={onCloseModal}
              />
            )}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading="Hygiene Command Center"
              isReload={getCommandCenterStats}
            />
          </Col>
        </Row>

        {/* <Row>
          <Col>
            <div className="hcc-last-updated">
              <ClockIconV3 color="#1e40af" />
              <span className="hcc-last-updated-text">
                Last updated: {lastUpdated.toLocaleTimeString()}
              </span>
            </div>
          </Col>
        </Row> */}

        <Row>
          <Col>
            <CommandCenterFilter
              allFilters={allFilters}
              setAllFilters={setAllFilters}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SummaryStatsCards />
          </Col>
        </Row>

        <Row>
          <Col>
            <TaskCompletionMatrix
              userInfoData={userInfoData}
              prevFilters={filters}
              setModValues={setModValues}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <GymComplianceTable
              userInfoData={userInfoData}
              prevFilters={filters}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HygieneCommandCenter;
